// extracted by mini-css-extract-plugin
module.exports = {"modalFooterButtons":"ShippingFormVariantEditionModal_modalFooterButtons__1sTuK"};